import { Box } from '@mui/material';
import React from 'react';
import Advantages from '../../components/front/Advantages';
import Banner from '../../components/front/Banner';
import CalculatorTeaser from '../../components/front/CalculatorTeaser';
import Footer from '../../components/front/Footer';
import Header from '../../components/front/Header';
import PlatformDetails from '../../components/front/PlatformDetails';
import Pricing from '../../components/front/Pricing';
import RegistrationForm from '../../components/front/RegistrationForm';
import Testimonials from '../../components/front/Testemonials';
import WhyUs from '../../components/front/WhyUs';
import './style.css';

const HomePage = () => (
    <Box className="public-site" sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
        <Header />
        <Banner />
        <PlatformDetails />
        <Advantages />
        <CalculatorTeaser />
        <Testimonials />
        <Pricing />
        <WhyUs />
        <RegistrationForm />
        <Footer />
    </Box>
);

export default HomePage;
